module.exports = __webpack_public_path__ + "media/images/tizymapold-e289e6ea3930d8a78b0b73caf6a60be3.svg";